import { useEffect, useState } from "react";

interface CampaignParams {
  utm: string | null;
  campaignId: string | null;
  campaigId: string | null;
  invite: string | null;
}

const useCampaignParams = (): [CampaignParams, boolean, () => void] => {
  const [campaignData, setCampaignData] = useState<CampaignParams>(() => {
    const storedUtm = localStorage.getItem("utm");
    const storedCampaignId = localStorage.getItem("campaignId");
    const storedCampaigId = localStorage.getItem("campaigId");
    const storedInvite = localStorage.getItem("invite");
    return {
      utm: storedUtm,
      campaignId: storedCampaignId,
      campaigId: storedCampaigId,
      invite: storedInvite,
    };
  });

  const [showModal, setShowModal] = useState<boolean>(false);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);

    const utm = params.get("utm");
    const invite = params.get("invite");
    const campaignId = params.get("campaignId");
    const campaigId = params.get("campaigId");

    const updateLocalStorage = (key: string, value: string | null) => {
      if (value && localStorage.getItem(key) !== value) {
        localStorage.setItem(key, value);
      }
    };

    if (utm || campaignId || invite || campaigId) {
      updateLocalStorage("utm", utm);
      updateLocalStorage("campaignId", campaignId);
      updateLocalStorage("campaigId", campaigId);

      const storedInvite = localStorage.getItem("invite");
      if (invite && (!storedInvite || storedInvite !== invite)) {
        //unmute when can change welcome texts
        // setShowModal(true);
        localStorage.setItem("invite", invite);
      }

      setCampaignData({
        utm: utm || campaignData.utm,
        campaignId: campaignId || campaignData.campaignId,
        campaigId: campaigId || campaignData.campaigId,
        invite: invite || campaignData.invite,
      });
    }
  }, []);

  const closeModal = () => setShowModal(false);

  return [campaignData, showModal, closeModal];
};
export default useCampaignParams;
